module.exports = __webpack_public_path__ + "img/aktsomhet.5d91062d.jpg";